import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useAuth from '../../../hooks/useAuth'
import { Helmet } from '@dr.pogodin/react-helmet'
import { Card as MuiCard, CardContent, Divider, LinearProgress, Typography } from '@mui/material'
import styled from '@emotion/styled'
import { spacing } from '@mui/system'
import IssuesGrid from '../../../components/entities/IssuesGrid'
import IssueApi from '../../../api/IssueApi'

const Card = styled(MuiCard)(spacing)

function AdminIssuesTable({ issues }) {
    return (
        <IssuesGrid
            issues={issues}
            fields={['issueType', 'shareName', 'tags', 'status', 'subEndDate', 'updatedAt']}
            pagination={true}
            pageSizeInitialState={100}
            pageSizeOptions={[10, 25, 100]}
            filters={true}
            detailsPath={(issue) => `/admin/issues/${issue.id}`}
            sortModel={[
                { field: 'status', sort: 'asc' },
                { field: 'updatedAt', sort: 'desc' },
            ]}
        />
    )
}

function AdminIssuesView() {
    const { t } = useTranslation()
    const [issues, setIssues] = useState(null)
    const { isAuthenticated } = useAuth()
    const issueApi = new IssueApi()

    useEffect(() => {
        async function fetchData() {
            if (!isAuthenticated) return
            const fetchedIssues = await issueApi.findAll()
            setIssues(fetchedIssues)
        }
        fetchData()
    }, [isAuthenticated])

    return (
        <React.Fragment>
            <Helmet title={t('entities.issue.plural')} />
            <Typography variant='h3' gutterBottom display='block'>
                {t('entities.issue.plural')}
            </Typography>

            <Divider my={6} />

            <Card mb={6}>
                <CardContent>
                    {!issues && <LinearProgress />}
                    {issues && <AdminIssuesTable issues={issues} />}
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export default AdminIssuesView
